module.exports = __webpack_public_path__ + "img/layout-blue.e9456eac.png";